import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { makeStyles } from '@mui/styles';
import {
	Link,
	Grid,
	TableRow,
	TableCell,
} from '@mui/material';

import { CircularProgressWithLabel, DataTable } from 'components';

const useStyles = makeStyles((theme) => ({
	root: {},
	content: {
		padding: 0,
	},
	inner: {
		minWidth: 700,
	},
	nameCell: {
		display: 'flex',
		alignItems: 'center',
	},
	avatar: {
		height: 42,
		width: 42,
		marginRight: theme.spacing(1),
	},
	actions: {
		padding: theme.spacing(1),
		justifyContent: 'flex-end',
	},
	primaryButton: {
		color: theme.palette.primary.main
	},
	errorButton: {
		color: theme.palette.error.main
	}
}));

const ElementDataTable = (props) => {
	const { className, data, activities, openActivityDetails, ...rest } = props;
	const classes = useStyles();
	const [rowsExpanded, setRowsExpanded] = useState();
	const _getTableColumns = () => (
		[
			{
				name: 'id',
				label: 'Id',
				options: {
					display: false,
					filter: false,
					viewColumns: false,
					filterType: 'textField',
				}
			},
			{
				name: 'element',
				label: 'Element',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			...activities.map((item, index) => ({
				name: `activity_${item.activityId}`,
				label: item.activityName,
				options: {
					display: !(index > 10),
					filterType: 'textField',
					customBodyRender: (value, tableMeta, updateValue) => {
						const { rowData } = tableMeta;
						const element = _.find(data, el => el.element === rowData[1]);
						return value && (
							<Link
								component="button"
								variant="body2"
								onClick={
									() => { openActivityDetails(item.activityId); }
								}
								underline="hover"
							>
								<CircularProgressWithLabel value={element[`activity_${item.activityId}`]} />
							</Link>
						);
					}
				}
			})),
		]
	);

	const _getTableOptions = () => ({
		filterType: 'dropdown',
		selectableRows: false,
		rowsExpanded,
		expandableRows: activities.length > 10, // Try Adding This
		renderExpandableRow: (rowData, rowMeta) => {
			const element = _.find(data, el => el.element === rowData[1]);

			return (
				<TableRow>
					<TableCell colSpan={activities.length}>
						<Grid container style={{ padding: 3, width: '100%' }} spacing={3}>
							{activities.slice(10).map(item => (
								<>
									<Grid item lg={4} xs={6}>
										{item.activityName}
									</Grid>
									<Grid item lg={8} xs={6}>
										{element[`activity_${item.activityId}`] && (
											<Link
												component="button"
												variant="body2"
												onClick={
													() => { openActivityDetails(item.activityId); }
												}
												underline="hover"
											>
												<CircularProgressWithLabel value={element[`activity_${item.activityId}`]} />
											</Link>
										)}
									</Grid>
								</>
							)
							)}
						</Grid>
					</TableCell>
				</TableRow>
			);
		},
		onRowsExpand: (currentRowsExpanded, allRowsExpanded) => {
			const expanded = allRowsExpanded.map(
				item => item.index
			);

			/* if (expanded.length > 1) {
								// limiting would go here
								expanded = expanded.slice(-1);
				} */
			setRowsExpanded(expanded);
		}
	});

	return (
		<div {...rest} className={clsx(classes.root, className)}>
			<DataTable
				id="ElementDataTable"
				title="All Elements"
				data={data}
				columns={_getTableColumns()}
				rowsPerPage={10}
				tableBodyCellMaxWidth="250"
				options={_getTableOptions()}
			/>
		</div>
	);
};

ElementDataTable.propTypes = {
	className: PropTypes.object,
	data: PropTypes.array,
	activities: PropTypes.array,
	openActivityDetails: PropTypes.func,
};

export default ElementDataTable;
